/**
 * routePath 模式匹配工具
 * 用于将动态配置中的 pageId（如 /product/:id）与实际 routePath（如 /product/123）匹配
 */

/**
 * 判断 routePath 模式是否匹配实际路径
 * 支持 `:param` 风格的动态段作为通配符
 * @param pattern 模式路径（如 /product/:id）
 * @param actual 实际路径（如 /product/123）
 * @returns 是否匹配
 */
export function matchRoutePath(pattern: string, actual: string): boolean {
  // 移除尾部斜杠后比较
  const normalizedPattern = pattern.replace(/\/+$/, '') || '/'
  const normalizedActual = actual.replace(/\/+$/, '') || '/'

  // 精确匹配
  if (normalizedPattern === normalizedActual) return true

  const patternSegments = normalizedPattern.split('/')
  const actualSegments = normalizedActual.split('/')

  // 段数不等则不匹配
  if (patternSegments.length !== actualSegments.length) return false

  // 逐段比较
  for (let i = 0; i < patternSegments.length; i++) {
    const pSeg = patternSegments[i]
    const aSeg = actualSegments[i]

    // 以 : 开头的段视为通配符，匹配任意非空段
    if (pSeg.startsWith(':')) {
      if (!aSeg) return false
      continue
    }

    // 其余做精确匹配
    if (pSeg !== aSeg) return false
  }

  return true
}

/**
 * 在 pages 配置中查找与 pageId 匹配的配置项
 * 支持动态路由匹配（如 /product/:id 匹配 /product/123）
 * @param pages 页面配置映射
 * @param pageId 当前 pageId
 * @returns 匹配到的 pageId，未匹配返回 null
 */
export function findMatchingPageId(
  pages: Record<string, unknown>,
  pageId: string
): string | null {
  // 1. 先尝试精确匹配
  if (pageId in pages) return pageId

  // 2. 尝试动态路由匹配
  for (const configPageId of Object.keys(pages)) {
    if (matchRoutePath(configPageId, pageId)) {
      return configPageId
    }
  }

  return null
}
